/* Mulbi - Promo regalos por monto + barra de progreso + timer */
(function () {
  'use strict';
  if (window.__mulbiPromoLoaded) return;
  window.__mulbiPromoLoaded = true;

  var C = window.MulbiPromo || { enabled: false, tiers: [], text: {} };
  var ROOT = C.root || '/';
  if (ROOT.slice(-1) !== '/') ROOT += '/';
  var rawFetch = window.fetch.bind(window);
  var tiers = (C.tiers || []).filter(function (t) { return t && t.variantId && t.min > 0; })
    .sort(function (a, b) { return a.min - b.min; });
  var giftIds = tiers.map(function (t) { return Number(t.variantId); });

  /* ---------- utilidades ---------- */
  function parseDate(s) {
    if (!s) return null;
    var m = String(s).trim().match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{2}))?$/);
    if (!m) return null;
    var p = function (n) { return ('0' + n).slice(-2); };
    /* Hora de Ciudad de México (UTC-6, sin horario de verano) */
    return new Date(m[1] + '-' + p(m[2]) + '-' + p(m[3]) + 'T' + p(m[4] || '0') + ':' + (m[5] || '00') + ':00-06:00').getTime();
  }
  function isActive() {
    if (!C.enabled || !tiers.length) return false;
    var now = Date.now(), s = parseDate(C.start), e = parseDate(C.end);
    if (s && now < s) return false;
    if (e && now > e) return false;
    return true;
  }
  function rate() {
    var r = window.Shopify && window.Shopify.currency && parseFloat(window.Shopify.currency.rate);
    return r && r > 0 ? r : 1;
  }
  function minCents(t) { return Math.round(t.min * 100 * rate()); }
  function isGift(item) { return giftIds.indexOf(Number(item.variant_id)) !== -1; }
  function baseOf(cart) {
    return (cart.items || []).reduce(function (a, i) { return isGift(i) ? a : a + (i.final_line_price || 0); }, 0);
  }
  function tierIndex(base) {
    var idx = -1;
    for (var i = 0; i < tiers.length; i++) if (base >= minCents(tiers[i])) idx = i;
    return idx;
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function money(c) {
    var fmt = (window.theme_variables && window.theme_variables.settings && window.theme_variables.settings.money_format) || C.moneyFormat;
    try { if (window.SHTHelper && window.SHTHelper.formatMoney && fmt) return window.SHTHelper.formatMoney(c, fmt); } catch (e) {}
    return '$' + (c / 100).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function moneyShort(c) { return money(c).replace(/[.,]00(?=\D*$)/, '').replace(/\s+/g, ''); }

  /* ---------- barra de progreso del carrito ---------- */
  function barHTML(base) {
    if (!isActive()) return '';
    var idx = tierIndex(base), next = tiers[idx + 1], max = minCents(tiers[tiers.length - 1]);
    var pct = Math.max(0, Math.min(100, (base / max) * 100));
    var T = C.text || {};
    var msg = next
      ? String(T.progress || 'Te faltan [monto] para llegar [regalo]').replace('[monto]', '<strong>' + money(minCents(next) - base) + '</strong>').replace('[regalo]', esc(next.label || next.name))
      : String(T.done || '¡Felicidades! Tu [regalo] de regalo ya está en tu carrito').replace('[regalo]', '<strong>' + esc(tiers[idx].name) + '</strong>');
    var h = '<p class="pgb__msg">' + msg + '</p>';
    h += '<div class="pgb__track" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + Math.round(pct) + '"><span class="pgb__fill" style="width:' + pct + '%"></span>';
    tiers.forEach(function (t, i) {
      h += '<span class="pgb__dot' + (i <= idx ? ' is-on' : '') + '" style="left:' + (minCents(t) / max) * 100 + '%"></span>';
    });
    h += '</div><div class="pgb__labels">';
    tiers.forEach(function (t, i) {
      h += '<span class="pgb__lbl' + (i <= idx ? ' is-on' : '') + (i === tiers.length - 1 ? ' is-last' : '') + '" style="left:' + (minCents(t) / max) * 100 + '%">' + moneyShort(minCents(t)) + '</span>';
    });
    h += '</div>';
    if (idx >= 0 && next && T.current) h += '<p class="pgb__current">' + String(T.current).replace('[regalo]', '<strong>' + esc(tiers[idx].name) + '</strong>') + '</p>';
    return h;
  }
  var lastBase = null;
  if (!customElements.get('promo-gift-bar')) {
    customElements.define('promo-gift-bar', class extends HTMLElement {
      connectedCallback() { this.paint(); }
      paint(b) {
        var base = b != null ? b : parseInt(this.dataset.base || '0', 10);
        var html = barHTML(base);
        this.innerHTML = html;
        this.hidden = !html;
      }
    });
  }
  function paintBars(base) {
    lastBase = base;
    document.querySelectorAll('promo-gift-bar').forEach(function (el) { el.dataset.base = base; if (el.paint) el.paint(base); });
  }

  /* ---------- refrescar carrito (drawer, página de carrito y contador) ---------- */
  function parse(html, sel) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.querySelector(sel);
  }
  function refreshUI() {
    var ids = [];
    var drawer = document.getElementById('cartDrawer');
    var mainForm = document.getElementById('mainCartForm');
    var mainId = mainForm && mainForm.dataset.sectionId;
    var hdr = document.getElementById('headerCartStatus');
    if (drawer) ids.push('cart-drawer');
    if (mainId) ids.push(mainId);
    if (hdr) ids.push('header-cart-status');
    if (!ids.length) return Promise.resolve();
    return rawFetch(window.location.pathname + '?sections=' + ids.join(','), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (s) {
        if (drawer && s['cart-drawer']) {
          var cur = drawer.querySelector('.js-cart-drawer-wrapper'), n = parse(s['cart-drawer'], '.js-cart-drawer-wrapper');
          if (cur && n) cur.innerHTML = n.innerHTML;
        }
        if (mainId && s[mainId]) {
          var cc = document.getElementById('mainCartContainer'), nc = parse(s[mainId], '#mainCartContainer');
          if (cc && nc) cc.innerHTML = nc.innerHTML;
        }
        if (hdr && s['header-cart-status']) {
          var nh = parse(s['header-cart-status'], '.shopify-section');
          if (nh) hdr.innerHTML = nh.innerHTML;
        }
        document.dispatchEvent(new CustomEvent('promo-regalos:updated'));
      })
      .catch(function (e) { console.warn('[promo-regalos] refresh', e); });
  }

  /* ---------- agregar / quitar regalos ---------- */
  var busy = false, again = false, timer = null;
  function reconcile() {
    if (busy) { again = true; return Promise.resolve(); }
    busy = true;
    return rawFetch(ROOT + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var base = baseOf(cart);
        var idx = isActive() ? tierIndex(base) : -1;
        var want = idx >= 0 ? Number(tiers[idx].variantId) : null;
        var updates = {}, changed = false;
        giftIds.forEach(function (id) {
          var qty = (cart.items || []).filter(function (i) { return Number(i.variant_id) === id; }).reduce(function (a, i) { return a + i.quantity; }, 0);
          var target = id === want ? 1 : 0;
          if (qty !== target) { updates[id] = target; changed = true; }
        });
        paintBars(base);
        if (!changed) return null;
        return rawFetch(ROOT + 'cart/update.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function (r) { return r.json(); }).then(function (res) {
          if (res && res.status && res.status >= 400) console.warn('[promo-regalos]', res);
          return refreshUI();
        });
      })
      .catch(function (e) { console.warn('[promo-regalos]', e); })
      .then(function () {
        busy = false;
        if (again) { again = false; return reconcile(); }
      });
  }
  function schedule(ms) {
    clearTimeout(timer);
    timer = setTimeout(reconcile, ms == null ? 350 : ms);
  }
  window.MulbiPromoReconcile = reconcile;

  /* Detectar cambios del carrito (fetch y XHR) */
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = rawFetch(input, init);
    if (CART_RE.test(url)) p.then(function () { schedule(); }, function () {});
    return p;
  };
  var xo = XMLHttpRequest.prototype.open, xs = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, u) { this.__promoUrl = u; return xo.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    if (CART_RE.test(String(this.__promoUrl || ''))) this.addEventListener('loadend', function () { schedule(); });
    return xs.apply(this, arguments);
  };

  /* Antes de ir al checkout, asegurar que el regalo correcto esté en el carrito */
  var goingToCheckout = false;
  function goCheckout(e) {
    if (goingToCheckout || !tiers.length) return;
    e.preventDefault(); e.stopPropagation();
    goingToCheckout = true;
    clearTimeout(timer);
    var finish = function () { window.location.href = ROOT + 'checkout'; };
    (busy ? new Promise(function (r) { setTimeout(r, 600); }) : Promise.resolve())
      .then(reconcile).then(finish, finish);
  }
  document.addEventListener('submit', function (e) {
    var b = e.submitter;
    if (b && b.name === 'checkout') goCheckout(e);
  }, true);
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (a && /\/checkout(\?|$)/.test(a.getAttribute('href'))) goCheckout(e);
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { schedule(0); });
  else schedule(0);

  /* ---------- barra de timer ---------- */
  if (!customElements.get('promo-countdown')) {
    customElements.define('promo-countdown', class extends HTMLElement {
      connectedCallback() {
        this.end = parseDate(this.dataset.end);
        this.start = parseDate(this.dataset.start);
        this.wrap = this.closest('[data-promo-timer]') || this;
        if (!this.end) { this.wrap.hidden = true; return; }
        this.tick();
        this.t = setInterval(this.tick.bind(this), 1000);
      }
      disconnectedCallback() { clearInterval(this.t); }
      set(u, v) { var el = this.querySelector('[data-u="' + u + '"]'); if (el) el.textContent = ('0' + v).slice(-2); }
      tick() {
        var now = Date.now(), d = this.end - now;
        if (d <= 0 || (this.start && now < this.start)) {
          this.wrap.hidden = true;
          if (d <= 0) clearInterval(this.t);
          return;
        }
        this.wrap.hidden = false;
        var s = Math.floor(d / 1000);
        this.set('d', Math.floor(s / 86400));
        this.set('h', Math.floor((s % 86400) / 3600));
        this.set('m', Math.floor((s % 3600) / 60));
        this.set('s', s % 60);
      }
    });
  }
})();
